/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import { ComponentInterface } from '@fusioncharts/core/src/component-interface';

import DragNodeLabels from '../../dragnode/dragablelabels';
import { toRaphaelColor, preDefStr, COMMASTRING, getFirstValue, pluck, BLANKSTRING,
  fcEach, hashify, HASHSTRING, pluckNumber, componentDispose, extend2, componentFactory, parseColor, getValidColor }
  from '@fusioncharts/core/src/lib';

let CLEAR_TIME_1000 = 1000,
  shapesInfo = {
    circle: 'circ',
    rectangle: 'rect',
    polygon: 'poly'
  },
  UNDEF,
  INPUT = preDefStr.INPUT,
  BLANKSPACE = preDefStr.BLANKSPACE,
  BLANK = preDefStr.BLANK,
  COLOR_FFFFFF = 'ffffff',
  PX = preDefStr.PX,
  COLOR_000000 = '000000',
  OPTIONSTR = '<option>',
  OPTIONCLOSESTR = '</option>',
  LABEL = preDefStr.LABEL,
  DATASET = preDefStr.DATASET,
  COMMA = preDefStr.COMMA,
  DATASETSTATE = 'appearing',
  ONE_PX_BORDER = '1px solid #cccccc',
  DISABLED = 'disabled',
  LABEL_ADDED = 'labeladded',
  OPTION_VALUE = '<option value="',
  CLOSE_TAG = '">',
  OPTION_STR = '</option>',
  NODE_ADDED = 'nodeAdded',
  NODE_UPDATED = 'nodeupdated',
  NODE_DELETED = 'nodedeleted',
  CONNECTOR_ADDED = 'connectoradded',
  CONNECTOR_UPDATED = 'connectorupdated',
  CONNECTOR_DELETED = 'connectordeleted',
  TRANSPARENT = 'transparent',
  DIV_STR = 'div',
  COLOR_EFEFEF = 'efefef',
  SUBMIT_STR = 'Submit',
  DELETE_STR = 'Delete',
  CANCEL_STR = 'Cancel',
  UPDATE_STR = 'update',
  APPEARING_STR = 'appearing',
  LABEL_DELETED = 'labeldeleted',
  removeElems = function (graphics) {
    for (var i in graphics) {
      graphics[i].remove();
    }
  },
  defined = function (obj) {
    return obj !== UNDEF && obj !== null;
  },
  // configures eventArgs with values of dataObj based on shapeType of node
  makeShapeSpecificModifications = function (eventArgs, dataObj) {
    switch (eventArgs.shape) {
      case preDefStr.CIRCLE:
        eventArgs.radius = dataObj.radius;
        break;
      case preDefStr.POLYGON:
        eventArgs.radius = dataObj.radius;
        eventArgs.sides = dataObj.numsides;
        break;
      default:
        eventArgs.width = dataObj.width;
        eventArgs.height = dataObj.height;
        break;
    }
  },
  _showNodeUpdateUI = (function () {
    // eslint-disable-next-line good-practices/no-function-dependency
    var manageShapeFields = function () {
        var ui = this.getGraphicalElement('cacheUpdateUI'),
          ele = ui.fields.shape, // eslint-disable-line good-practices/no-single-usage-variable
          shapeFields = ['rectWidth', 'rectHeight', 'circPolyRadius', 'polySides'],
          i = shapeFields.length,
          key;

        while (i--) {
          key = shapeFields[i];
          if (/rect|poly|circ/ig.test(key)) {
            ui.labels[key].hide();
            ui.fields[key].hide();
          }
          if (new RegExp(pluck(ele.val(), 'rect'), 'ig').test(key)) {
            ui.labels[key].show();
            ui.fields[key].show();
          }
        }
      },
      // eslint-disable-next-line good-practices/no-function-dependency
      showGivenColor = function () {
        var fields = this.getGraphicalElement('cacheUpdateUI').fields,
          color = getValidColor(fields.color.val());

        color && fields.colorOut.css({
          background: parseColor(color)
        });
      },
      // eslint-disable-next-line good-practices/no-function-dependency
      manageImageFields = function (animate) {
        var manager = this,
          ui = manager.getGraphicalElement('cacheUpdateUI'),
          animationManager = manager.getFromEnv('animationManager'),
          chartHeight = manager.getFromEnv('chartConfig').height, // eslint-disable-line good-practices/no-single-usage-variable
          padding = 5,
          isChecked = ui.fields.image.val(),
          imgKey = ['imgWidth', 'imgHeight', 'imgAlign', 'imgUrl'],
          dialogHeight,
          i,
          key;

        dialogHeight = isChecked ? 250 : 215;

        if (animate) {
          ui.ok.hide();
          ui.cancel.hide();
          ui.removeItem.hide();
          ui.error.hide();
        }
        i = imgKey.length;
        // eslint-disable-next-line no-unmodified-loop-condition
        while (!isChecked && i--) {
          key = imgKey[i];
          ui.labels[key].hide();
          ui.fields[key].hide();
        }
        animate && animationManager.setAnimationState('uichange');
        animationManager.setAnimation({
          el: ui.dialog,
          state: 'updating',
          attr: {
            top: (chartHeight - dialogHeight) / 2,
            height: dialogHeight
          },
          component: manager,
          label: 'uidialog',
          callback: function () {
            i = imgKey.length;
            // eslint-disable-next-line no-unmodified-loop-condition
            while (i-- && isChecked) {
              key = imgKey[i];
              ui.labels[key].show();
              ui.fields[key].show();
            }
            ui.ok.attr({
              y: dialogHeight - 23 - padding
            }).show();
            ui.cancel.attr({
              y: dialogHeight - 23 - padding
            }).show();
            ui.removeItem.attr({
              y: dialogHeight - 23 - padding
            });
            ui.error.attr({
              y: dialogHeight - 23 - padding + 4
            }).show();
            if (ui.edit) {
              ui.removeItem.show();
            } else {
              ui.removeItem.hide();
            }
          }
        });
      };

    return function (config, edit) {
      var manager = this,
        // graphics = manager.graphics,
        ui = manager.getGraphicalElement('cacheUpdateUI'),
        // nodes = manager.nodes,
        // conf = chart.config,
        paper = manager.getFromEnv('paper'),
        borderStyle = ONE_PX_BORDER,
        inputStyle = {
          width: 80 + PX,
          border: borderStyle,
          fontSize: 10 + PX,
          lineHeight: 15 + PX,
          padding: 2 + PX,
          fontFamily: (manager.getFromEnv('style').inCanvasStyle || {}).fontFamily
        },
        noUIfound,
        labelStyle = { // eslint-disable-line good-practices/no-single-usage-variable
          textAlign: 'right'
        },
        fields = ui && ui.fields,
        labels = ui && ui.labels,
        dialog,
        // node,
        // index,
        onSubmit = function (event) {
          event.stopPropagation();
          var uiFields = ui && ui.fields, // eslint-disable-line good-practices/no-single-usage-variable
            uiEdit = ui.edit,
            idFound,
            id,
            submitObj;

          if (fields) {
            submitObj = {
              x: getFirstValue(fields.x.val(), manager.getFromEnv('xAxis').getLimit().min),
              y: getFirstValue(fields.y.val(), manager.getFromEnv('yAxis').getLimit().min),
              id: id = fields.id.val(),
              datasetId: fields.dataset.val(),
              name: fields.label.val(),
              tooltext: fields.tooltip.val(),
              color: fields.color.val(),
              alpha: fields.alpha.val(),
              labelalign: fields.labelalign.val(),
              allowdrag: fields.draggable.val(),
              imagenode: fields.image.val(),
              imagewidth: fields.imgWidth.val(),
              imageheight: fields.imgHeight.val(),
              imagealign: fields.imgAlign.val(),
              imageurl: fields.imgUrl.val(),
              link: fields.link.val()
            };

            // Shape specific configurations.
            switch (uiFields.shape.val()) {
              case 'circ':
                submitObj.shape = preDefStr.CIRCLE;
                submitObj.radius = fields.circPolyRadius.val();
                break;
              case 'poly':
                submitObj.shape = preDefStr.POLYGON;
                submitObj.radius = fields.circPolyRadius.val();
                submitObj.numsides = fields.polySides.val();
                break;
              default:
                submitObj.shape = preDefStr.RECTANGLE;
                submitObj.width = fields.rectWidth.val();
                submitObj.height = fields.rectHeight.val();
                break;
            }

            // Check if node already exists
            if (manager.getNode(submitObj.id)) {
              idFound = true;
            }

            // If node already exists then we do not add a node and show an error
            if (!idFound || uiEdit !== UNDEF) {
              // node = nodes[submitObj.id] || {};
              id = submitObj.datasetId;
              // Dont add nodes when dataset id is not given
              if (id !== BLANKSTRING || uiEdit) {
                id = Number(id);
                // index = node.config && node.config.index;
                uiEdit ? manager.updateNode(submitObj) : manager.addNode(submitObj);
                ui.hide();
                ui.visible = false;
              }
              return;
            }
            ui.error.attr({
              text: 'ID already exist.'
            });
            fields.label.focus();
          }
          // Remobe disabled from attr
          ui.enableFields();
        },
        onCancel = function (event) {
          event.stopPropagation();
          // Hide the UI
          ui.hide();
          ui.visible = false;
          // Remobe disabled from attr
          ui.enableFields();
          // Hide error msg
          ui.error.attr({
            text: BLANK
          });
          ui.visible = false;
        },
        onDelete = function (event) {
          event.stopPropagation();
          manager.deleteNode(ui.fields.id.val());
          ui.hide();
          ui.visible = false;
        };

      manager.getFromEnv('animationManager').setAnimationState('uichange');
      if (!ui) {
        noUIfound = true;
      }
      ui = manager.addGraphicalElement('cacheUpdateUI', manager.createHtmlDialog(
        350, 215, onSubmit, onCancel, onDelete, ui));

      if (noUIfound) {
        // add fields.
        dialog = ui.dialog;
        labels = ui.labels = {};
        fields = ui.fields = {};
      }
      ui.config = config;
      ui.edit = edit;
      if (!ui.error) {
        ui.error = paper.html('span', {
          color: 'ff0000',
          x: 30,
          y: 228
        }, UNDEF, dialog);
      }
      if (!ui.enableFields) {
        ui.enableFields = function () {
          var key;
          for (key in config) {
            if (config[key] && config[key].disabled && fields[key]) {
              fields[key].element.removeAttribute('disabled');
            }
          }
        };
      }
      if (!ui.clearFields) {
        ui.clearFields = function () {
          var key;
          for (key in ui.fields) {
            if (!fields[key].element.disabled) {
              fields[key].element.value = BLANKSTRING;
            }
          }
        };
      }

      fcEach(this.nodeUpdateUIDefinition, function (def) {
        var field,
          key = def.key,
          attrs = {},
          confObj = config[key] || {},
          innerHTML,
          value;

        !labels[key] && (labels[key] = paper.html(LABEL, {
          x: def.x,
          y: def.y,
          width: def.labelWidth || 45,
          text: def.text
        }, labelStyle, dialog));

        // No need to proceed of this label has no input box
        // associated with itself.
        if (def.noInput) {
          return;
        }

        field = fields[key];

        if (!field) {
          inputStyle.border = def.type === 'checkbox' ? BLANK : borderStyle;
          field = fields[key] =
              paper.html(def.inputType || 'input', {
                x: (def.labelWidth && (def.labelWidth + 5)) || 50,
                y: -2 + (def.inputPaddingTop || 0),
                width: def.inputWidth || 50,
                name: key || BLANKSTRING
              }, inputStyle);

          if (def.inputType !== 'select') {
            field.attr({
              type: def.type || 'text'
            }).on('keyup', ui.handleKeyPress);
          }
          field.add(labels[key]);
        }

        if (defined(innerHTML = getFirstValue(confObj.innerHTML, def.innerHTML))) { // eslint-disable-line good-practices/no-single-usage-variable
          attrs.innerHTML = innerHTML;
        }
        if (confObj.disabled) {
          attrs.disabled = DISABLED;
        } else {
          field.element && (field.element.disabled = false);
        }
        field.attr(attrs);
        if (defined(value = getFirstValue(confObj.value, def.value))) { // eslint-disable-line good-practices/no-single-usage-variable
          field.val(value);
        }
        // eslint-disable-next-line good-practices/no-function-dependency
        key === 'shape' && field.on('change', function () {
          manageShapeFields.call(manager);
        });
        // eslint-disable-next-line good-practices/no-function-dependency
        key === 'image' && field.on('fc-click', function () {
          manageImageFields.call(manager, true);
        });
        // eslint-disable-next-line good-practices/no-function-dependency
        key === 'color' && field.on('keyup', function () {
          showGivenColor.call(manager);
        });
      });

      showGivenColor.call(this);
      manageImageFields.call(this);
      manageShapeFields.call(this);
      ui.visible = true;
      ui.fields[edit ? LABEL : 'id'].focus();
    };
  })();

/**
 * Class for dragnodes's group
 */
class DragNodeGroup extends ComponentInterface {
  /**
   * constructor function this class
   */
  constructor () {
    super();
    var manager = this;
    manager.setState('visible', true);
    manager.connectorUpdateUIDefinition = [{
      key: 'fromid',
      text: 'Connect From',
      inputType: 'select',
      x: 10,
      y: 15,
      labelWidth: 80,
      inputWidth: 100
    }, {
      key: 'toid',
      text: 'Connect To',
      inputType: 'select',
      x: 10,
      y: 40,
      labelWidth: 80,
      inputWidth: 100
    }, {
      key: 'arratstart',
      text: 'Arrow At Start',
      x: 200,
      y: 15,
      type: 'checkbox',
      inputPaddingTop: 3,
      labelWidth: 80,
      inputWidth: 15
    }, {
      key: 'arratend',
      text: 'Arrow At End',
      x: 200,
      y: 40,
      type: 'checkbox',
      inputPaddingTop: 3,
      labelWidth: 80,
      inputWidth: 15
    }, {
      key: LABEL,
      text: 'Label',
      x: 10,
      y: 75,
      labelWidth: 40,
      inputWidth: 120
    }, {
      key: 'id',
      text: 'Node ID',
      x: 190,
      y: 75,
      inputWidth: 55
    }, {
      key: 'color',
      text: 'Color',
      x: 10,
      y: 100,
      labelWidth: 40,
      inputWidth: 35
    }, {
      key: 'alpha',
      text: 'Alpha',
      x: 110,
      y: 100,
      inputWidth: 25,
      labelWidth: 35
    }, {
      key: 'strength',
      text: 'Strength',
      x: 190,
      y: 100,
      inputWidth: 55,
      val: '0.1'
    }, {
      key: 'url',
      text: 'Link',
      x: 10,
      y: 125,
      labelWidth: 40,
      inputWidth: 120
    }, {
      key: 'tooltext',
      text: 'Tooltip',
      x: 190,
      y: 125,
      labelWidth: 40,
      inputWidth: 60
    }, {
      key: 'dashed',
      text: 'Dashed',
      x: 10,
      y: 150,
      type: 'checkbox',
      inputPaddingTop: 3,
      inputWidth: 15,
      labelWidth: 40
    }, {
      key: 'dashgap',
      text: 'Dash Gap',
      x: 85,
      y: 150,
      labelWidth: 60,
      inputWidth: 25
    }, {
      key: 'dashlen',
      text: 'Dash Length',
      x: 190,
      y: 150,
      labelWidth: 70,
      inputWidth: 30
    }];
    manager.nodeUpdateUIDefinition = [{
      key: 'id',
      text: 'Id',
      inputWidth: 60,
      x: 10,
      y: 15
    }, {
      key: DATASET,
      text: DATASET,
      inputType: 'select',
      inputWidth: 110,
      innerHTML: UNDEF,
      x: 170,
      y: 15
    }, {
      key: 'x',
      text: 'Value',
      x: 10,
      y: 40,
      inputWidth: 21
    }, {
      key: 'y',
      text: COMMA,
      x: 88,
      y: 40,
      inputWidth: 21,
      labelWidth: 5
    }, {
      text: '(x, y)',
      x: 125,
      y: 40,
      labelWidth: 33,
      noInput: true
    }, {
      key: 'tooltip',
      text: 'Tooltip',
      inputWidth: 105,
      x: 170,
      y: 40
    }, {
      key: LABEL,
      text: 'Label',
      inputWidth: 92,
      x: 10,
      y: 65
    }, {
      key: 'labelalign',
      text: 'Align',
      labelWidth: 70,
      inputWidth: 110,
      inputType: 'select',
      innerHTML: '<option></option><option value="top">Top</option><option value="middle">Middle</option>' +
          '<option value="bottom">Bottom</option>',
      x: 145,
      y: 63
    }, {
      key: 'color',
      text: 'Color',
      x: 10,
      y: 90,
      inputWidth: 60
    }, {
      key: 'colorOut',
      innerHTML: '&nbsp;',
      x: 85,
      y: 90,
      inputWidth: 15,
      inputType: 'span'
    }, {
      key: 'alpha',
      text: 'Alpha',
      x: 170,
      y: 90,
      inputWidth: 20
    }, {
      key: 'draggable',
      text: 'Allow Drag',
      value: true,
      inputWidth: 20,
      x: 250,
      y: 90,
      labelWidth: 58,
      inputPaddingTop: 3,
      type: 'checkbox'
    }, {
      key: 'shape',
      text: 'Shape',
      inputType: 'select',
      inputWidth: 97,
      innerHTML: '<option value="rect">Rectangle</option><option value="circ">Circle</option><option ' +
          'value="poly">Polygon</option>',
      x: 10,
      y: 115
    }, {
      key: 'rectHeight',
      text: 'Height',
      x: 170,
      y: 115,
      inputWidth: 20
    }, {
      key: 'rectWidth',
      text: 'Width',
      x: 255,
      y: 115,
      inputWidth: 20
    }, {
      key: 'circPolyRadius',
      text: 'Radius',
      x: 170,
      y: 115,
      inputWidth: 20
    }, {
      key: 'polySides',
      text: 'Sides',
      x: 255,
      y: 115,
      inputWidth: 20
    }, {
      key: 'link',
      text: 'Link',
      x: 10,
      y: 140,
      inputWidth: 92
    }, {
      key: 'image',
      text: 'Image',
      type: 'checkbox',
      inputPaddingTop: 4,
      inputWidth: 20,
      x: 10,
      y: 170
    }, {
      key: 'imgUrl',
      text: 'URL',
      inputWidth: 105,
      x: 170,
      y: 170
    }, {
      key: 'imgWidth',
      text: 'Width',
      inputWidth: 20,
      x: 10,
      y: 195
    }, {
      key: 'imgHeight',
      text: 'Height',
      inputWidth: 20,
      x: 82,
      y: 195
    }, {
      key: 'imgAlign',
      text: 'Align',
      inputType: 'select',
      inputWidth: 75,
      innerHTML: '<option value="top">Top</option><option value="middle">Middle</option><option ' +
          'value="bottom">Bottom</option>',
      x: 170,
      y: 195
    }];
    manager.labelUpdateUIDefinition = [{
      key: LABEL,
      text: 'Label*',
      x: 10,
      y: 15,
      inputWidth: 235
    }, {
      key: 'size',
      text: 'Size',
      x: 10,
      y: 40
    }, {
      key: 'padding',
      text: 'Padding',
      x: 10,
      y: 65
    }, {
      key: 'x',
      text: 'Position',
      x: 120,
      y: 65,
      labelWidth: 70,
      inputWidth: 25
    }, {
      key: 'y',
      text: COMMA,
      x: 225,
      y: 65,
      labelWidth: 10,
      inputWidth: 25
    }, {
      key: 'xy',
      text: '(x, y)',
      x: 260,
      y: 65,
      noInput: true
    }, {
      key: 'allowdrag',
      text: 'Allow Drag',
      x: 120,
      y: 40,
      inputType: 'checkbox',
      inputPaddingTop: 3,
      inputWidth: 15,
      labelWidth: 70,
      val: 1
    }, {
      key: 'color',
      text: 'Color',
      x: 10,
      y: 90
    }, {
      key: 'alpha',
      text: 'Alpha',
      x: 145,
      y: 90,
      inputWidth: 30,
      val: preDefStr.HUNDREDSTRING
    }, {
      key: 'bordercolor',
      text: 'Border Color',
      x: 10,
      y: 125,
      labelWidth: 100
    }, {
      key: 'bgcolor',
      text: 'Background Color',
      x: 10,
      y: 150,
      labelWidth: 100
    }];
  }

  /**
   * Function used to differentiate between update and resize
   */
  configure () {
    this.setState('configured', true);
  }

  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'group';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'dragNodeGroup';
  }
  /**
   * Funtion to create the UI box for adding new labels
   * @param {Object} options Any predefined options to be added to the UI box
   */
  showLabelUpdateUI (options = {}) {
    var manager = this,
      paper = manager.getFromEnv('paper'),
      // conf = manager.getFromEnv('chartConfig'),
      ui = manager.getGraphicalElement('cacheLabelUpdateUI'),
      inputStyle = { // eslint-disable-line good-practices/no-single-usage-variable
        border: '1px solid #cccccc',
        fontSize: 10 + PX,
        lineHeight: 15 + PX,
        fontFamily: (manager.getFromEnv('style').inCanvasStyle || {}).fontFamily,
        padding: 2 + PX
      },
      labelStyle = { // eslint-disable-line good-practices/no-single-usage-variable
        textAlign: 'right'
      },
      noUIfound,
      fields = ui && ui.fields,
      labels = ui && ui.labels,
      field,
      value,
      dialog;

    manager.getFromEnv('animationManager').setAnimationState('uichange');
    if (!ui) {
      noUIfound = true;
    }
    ui = manager.addGraphicalElement('cacheLabelUpdateUI', manager.createHtmlDialog(315, 205,
      function () {
        var uiFields = ui && ui.fields,
          submitObj;
        if (uiFields) {
          // Prepare obbject for submission.
          submitObj = {
            text: uiFields.label.val(),
            x: uiFields.x.val(),
            y: uiFields.y.val(),
            color: uiFields.color.val(),
            alpha: uiFields.alpha.val(),
            bgcolor: uiFields.bgcolor.val(),
            bordercolor: uiFields.bordercolor.val(),
            fontsize: uiFields.size.val(),
            allowdrag: uiFields.allowdrag.val(),
            padding: uiFields.padding.val()
          };

          if (submitObj.text) {
            manager.addLabel && manager.addLabel(submitObj);
            ui.hide();
          } else {
            ui.error.attr({
              text: 'Label cannot be blank.'
            });
            fields.label.focus();
          }
        }
      },
      function () {
        ui.error.attr({
          text: BLANKSTRING
        });
        ui.hide();
      }, UNDEF, ui));

    if (noUIfound) {
      dialog = ui.dialog;
      labels = ui.labels = {};
      fields = ui.fields = {};
    }

    fcEach(manager.labelUpdateUIDefinition, function (def) {
      var key = def.key;

      if (!labels[key]) {
        labels[key] = paper.html(LABEL, {
          x: def.x,
          y: def.y,
          width: def.labelWidth || 45,
          text: def.text
        }, labelStyle, dialog);
      }

      // No need to proceed of this label has no input box
      // associated with itself.
      if (def.noInput) {
        return;
      }

      if (!(field = fields[key])) { // eslint-disable-line good-practices/no-single-usage-variable
        field = fields[key] = paper.html(INPUT, {
          y: -2 + (def.inputPaddingTop || 0),
          x: (def.labelWidth && (def.labelWidth + 5)) || 50,
          width: def.inputWidth || 50,
          type: def.inputType || 'text',
          name: key || BLANKSTRING
        }, inputStyle, labels[key]).on('keyup', ui.handleKeyPress);
      }

      if (defined(value = getFirstValue(options[key], def.val))) { // eslint-disable-line good-practices/no-single-usage-variable
        field.val(value);
      }
    });

    if (!ui.error) {
      ui.error = paper.html('span', {
        color: 'ff0000',
        x: 10,
        y: 180
      }, UNDEF, dialog);
    }

    // Focus on label textbox
    ui.fields.label.focus();
  }

  /**
   * Function to restore all the data of dragnode to its initial visual
   */
  restoreData () {
    var manager = this,
      // manager = chart.components['datasetGroup_' + chart.defaultDatasetType],
      datasets = manager.getChildren('dataset'),
      chart = manager.getFromEnv('chart'),
      showlegend = pluckNumber(chart.config.showlegend, 0), // eslint-disable-line good-practices/no-single-usage-variable
      connectors = manager.getChildren('connector'),
      jsonData = chart.getFromEnv('dataSource'),
      i,
      dataset,
      dataStore,
      dataObj,
      graphics,
      labelObj,
      len,
      labelSet = manager.getChildren('labels'),
      removeElements = function (datastore) {
        var j,
          ele;
        for (j = 0; j < (datastore && datastore.length); j++) {
          dataObj = datastore[j];
          delete dataObj.removed;
          if (dataObj.config.add) {
            graphics = datastore[j].graphics;
            for (ele in graphics) {
              graphics[ele].remove();
            }
            datastore.splice(j, 1);
            j--;
          }
        }
      },
      restoreDatasets = function (k, dataSets, json) {
        dataset = dataSets[k];
        dataStore = dataset.components.data; // eslint-disable-line good-practices/no-single-usage-variable
        removeElements(dataStore);
        dataset.drawn = false;
        dataset.configure(json[k]);
      };
    for (i = 0, len = datasets && datasets.length; i < len; i++) {
      restoreDatasets(i, datasets, jsonData.dataset);
    }
    for (i = 0, len = connectors && connectors.length; i < len; i++) {
      restoreDatasets(i, connectors, jsonData.connectors);
    }
    if (labelSet && labelSet.length) {
      labelObj = labelSet[0];
      dataStore = labelObj.components.data;
      dataStore && removeElements(dataStore);
      labelObj.configure(jsonData.labels);
    }

    chart.fireChartInstanceEvent('dataRestored');
    manager.asyncDraw();
    showlegend && manager.getFromEnv('legend').asyncDraw();
  }

  /**
   * Function to add a draggable-label via UI
   * @param {Object} labelObj Conatins the information about the label that is to be added
   */
  addLabel (labelObj) {
    var manager = this,
      labelDS = manager.getChildren('labels'),
      sourceEvent = LABEL_ADDED,
      dataStore,
      eventArgs,
      chart = manager.getFromEnv('chart'),
      len;
    labelObj.add = true;

    // Creating an instance of the label class if not already present
    if (labelDS && labelDS[0]) {
      labelDS = labelDS[0];
    } else {
      componentFactory(manager, DragNodeLabels, 'labels', 1, [{}]);
      labelDS = manager.getChildren('labels')[0];
    }
    dataStore = labelDS.components.data || (labelDS.components.data = []);
    len = dataStore.length;
    labelDS._setConfigure(len, labelObj);
    // }

    eventArgs = {
      text: labelObj.text,
      x: labelObj.x,
      y: labelObj.y,
      allowdrag: labelObj.allowdrag,
      sourceType: 'labelnode',
      link: labelObj.link
    };
    chart.fireChartInstanceEvent('chartupdated', extend2({
      sourceEvent: sourceEvent
    }, eventArgs));
    chart.fireChartInstanceEvent(sourceEvent, eventArgs);
    labelDS.asyncDraw();
  }

  /**
   * Funtion to create the options for the dialog box used for adding new nodes
   */
  showNodeAddUI () {
    var manager = this,
      // chart = manager.chart,
      datasets = manager.getChildren('dataset'),
      datasetDropDownStr = BLANKSTRING, // eslint-disable-line good-practices/no-single-usage-variable
      conf,
      dataset,
      type,
      i;
    for (i = 0; i < datasets.length; i++) {
      dataset = datasets[i] || {};
      conf = dataset.config;
      type = dataset.getName();
      if (type === 'dragNode') {
        datasetDropDownStr += OPTION_VALUE + dataset.config.datasetIndex + CLOSE_TAG + (((conf.name !== BLANK && conf.name !==
          UNDEF) && conf.name + COMMASTRING + BLANKSPACE) || BLANK) + dataset.config.datasetIndex + OPTION_STR;
      }
    }
    manager.showNodeUpdateUI({
      dataset: {
        innerHTML: datasetDropDownStr
      }
    });
  }

  /**
   * Funtion to create the options for the dialog box used for adding new connectors
   */
  showConnectorAddUI () {
    var manager = this,
      // chart = manager.chart,
      nodes = manager.getNode(),
      nodeStr = BLANKSTRING,
      id,
      i,
      config,
      node;
    for (i in nodes) {
      node = nodes[i];
      config = node.config;
      id = config.id;
      nodeStr += OPTION_VALUE + id + CLOSE_TAG + id + OPTION_STR;
    }
    manager.showConnectorUpdateUI({
      fromid: {
        innerHTML: nodeStr
      },
      toid: {
        innerHTML: nodeStr
      }
    });
  }

  /**
   * Function to create the UI box for adding/updating the connectors
   * @param {Object} config Has the information about the concerned connector
   * @param {boolean} edit Flag for determining if a new connector has to be added or existing connector has to be
   * updated
   */
  showConnectorUpdateUI (config, edit) {
    var manager = this,
      renderer = manager.getFromEnv('paper'),
      uiName = `cacheConnectorUpdateUI${edit ? 'edit' : 'new'}`,
      ui = manager.getGraphicalElement(uiName),
      inputStyle = { // eslint-disable-line good-practices/no-single-usage-variable
        border: '1px solid #cccccc',
        fontSize: 10 + PX,
        lineHeight: 15 + PX,
        fontFamily: (manager.getFromEnv('style').inCanvasStyle || {}).fontFamily,
        padding: 2 + PX
      },
      noUIfound,
      labelStyle = { // eslint-disable-line good-practices/no-single-usage-variable
        textAlign: 'right'
      },
      fields = ui && ui.fields,
      labels = ui && ui.labels,
      innerHTML,
      field,
      value,
      onDelete = function () {
        var uiFields = ui && ui.fields;

        manager.deleteConnector({
          from: uiFields.fromid.val(),
          to: uiFields.toid.val(),
          id: uiFields.id.val()
        });
        ui.hide();
      },
      dialog;

    manager.getFromEnv('animationManager').setAnimationState('uichange');
    if (!ui) {
      noUIfound = true;
    }

    ui = manager.addGraphicalElement(uiName, manager.createHtmlDialog(
      315, 215,
      function () {
        var uiFields = ui && ui.fields,
          submitObj;
        if (uiFields) {
          submitObj = {
            from: uiFields.fromid.val(),
            to: uiFields.toid.val(),
            id: uiFields.id.val(),
            label: uiFields.label.val(),
            color: uiFields.color.val(),
            alpha: uiFields.alpha.val(),
            link: uiFields.url.val(),
            tooltext: uiFields.tooltext.val(),
            strength: uiFields.strength.val(),
            arrowatstart: uiFields.arratstart.val(),
            arrowatend: uiFields.arratend.val(),
            dashed: uiFields.dashed.val(),
            dashlen: uiFields.dashlen.val(),
            dashgap: uiFields.dashgap.val()
          };

          // Validate
          if (submitObj.from) {
            if (submitObj.to) {
              if (submitObj.from !== submitObj.to) {
                edit ? manager.editConnector(submitObj)
                  : manager.addConnector(submitObj);
                ui.enableFields();
                ui.hide();
                ui.clearFields();
              } else {
                ui.error.attr({
                  text: 'Connector cannot start and end at the same node!'
                });
                fields.fromid.focus();
              }
            } else {
              ui.error.attr({
                text: 'Please select a valid connector end.'
              });
              fields.toid.focus();
            }
          } else {
            ui.error.attr({
              text: 'Please select a valid connector start.'
            });
            fields.fromid.focus();
          }
        }
      },
      // Cancel function
      function () {
        ui.error.attr({
          text: BLANKSTRING
        });
        ui.enableFields();
        ui.hide();
      },
      // Delete function
      onDelete, ui));

    if (noUIfound) {
      dialog = ui.dialog;
      labels = ui.labels = {};
      fields = ui.fields = {};
    }

    ui.config = config;
    if (!ui.enableFields) {
      ui.enableFields = function () {
        var key;
        for (key in config) {
          if (config[key] && config[key].disabled && fields[key]) {
            fields[key].element.removeAttribute('disabled');
          }
        }
      };
    }
    if (!ui.clearFields) {
      ui.clearFields = function () {
        var key,
          uiFields = ui.fields;
        for (key in uiFields) {
          if (!uiFields[key].element.disabled) {
            uiFields[key].element.value = BLANKSTRING;
          }
        }
      };
    }

    fcEach(manager.connectorUpdateUIDefinition, function (def) {
      var key = def.key,
        attr = config[key] || {};

      if (!labels[key]) {
        labels[key] = renderer.html(LABEL, {
          x: def.x,
          y: def.y,
          width: def.labelWidth || 45,
          text: def.text
        }, labelStyle, dialog);
      }

      // No need to proceed of this label has no input box
      // associated with itself.
      if (def.noInput) {
        return;
      }

      if (!(field = fields[key])) {
        field = fields[key] = renderer.html(def.inputType || INPUT, {
          y: -2 + (def.inputPaddingTop || 0),
          x: (def.labelWidth && (def.labelWidth + 5)) || 50,
          width: def.inputWidth || 50,
          name: key || BLANKSTRING
        }, inputStyle);

        if (def.inputType !== 'select') {
          field.attr({
            type: def.type || 'text'
          }).on('keyup', ui.handleKeyPress);
        }
        field.add(labels[key]);
      }

      if ((innerHTML = pluck(attr.innerHTML, def.innerHTML))) { // eslint-disable-line good-practices/no-single-usage-variable
        field.attr({
          innerHTML: innerHTML
        });
      }
      if ((value = pluck(attr.val, def.val)) !== UNDEF) { // eslint-disable-line good-practices/no-single-usage-variable
        field.val(value);
      }
      if (attr.disabled) {
        field.attr({
          disabled: 'disabled'
        });
      } else {
        field.element && (field.element.disabled = false);
      }
    });

    // dash checking and ui modification
    // call to set default fro the first time
    ui.checkDash = function () {
      var showHideFn = (fields.dashed && fields.dashed.val()) ? 'show' : 'hide';
      labels.dashgap && labels.dashgap[showHideFn]();
      fields.dashgap && fields.dashgap[showHideFn]();
      labels.dashlen && labels.dashlen[showHideFn]();
      fields.dashlen && fields.dashlen[showHideFn]();
    };
    ui.checkDash();
    fields.dashed.on('fc-click', ui.checkDash);

    if (!ui.error) {
      ui.error = renderer.html('span', {
        color: 'ff0000',
        x: 10,
        y: 170
      }, UNDEF, dialog);
    }

    ui.removeItem[edit ? 'show' : 'hide']();
  }

  /**
   * Function to create the UI box for adding/updating the nodes
   * @return {Function} The actual function for updating/adding the nodes
   */
  showNodeUpdateUI () {
    return _showNodeUpdateUI.apply(this, arguments);
  }

  /**
   * Function for adding new nodes
   * @param {Object} dataObj Contains information about the node that is to be added
   */
  addNode (dataObj) {
    var manager = this,
      datasets = manager.getChildren('dataset'),
      len = datasets.length, // eslint-disable-line good-practices/no-single-usage-variable
      dataset,
      index,
      idFound,
      id,
      i,
      eventArgs,
      sourceEvent = NODE_ADDED,
      chart = manager.getFromEnv('chart'),
      dataStore;

    for (i = 0; i < len; i++) {
      dataset = datasets[i] || {};
      id = dataset.config.datasetIndex;
      if (id !== UNDEF) {
        id = id.toString();
      }
      if (id === dataObj.datasetId) {
        idFound = true;
        break;
      }
    }
    if (dataset && idFound) {
      dataStore = dataset.components.data;
      dataObj.add = true;
      // This is the index of the new data
      index = dataStore.length;
      eventArgs = {
        index: index, // to be deprecated
        dataIndex: index,
        link: dataObj.link,
        y: dataObj.y,
        x: dataObj.x,
        shape: dataObj.shape,
        label: dataObj.name,
        toolText: dataObj.tooltext,
        id: dataObj.id,
        datasetIndex: dataset.config.datasetIndex,
        datasetName: dataset.config.seriesname,
        sourceType: 'dataplot'
      };

      // configure the eventArgs based on the type of shape
      makeShapeSpecificModifications(eventArgs, dataObj);

      dataset._setConfigure(index, dataObj);
      dataset.parsePlotAttributes(index);
      dataset._drawNode(index);
      dataset.setState('dirty', true);
      // manager._redrawDragNode(eventArgs, sourceEvent);
      /**
       * In `DragNode` charts, data points are represented as nodes whose
       * properties like location(x,y), shape, dimensions and color can be added dynamically to
       * the chart. Chart can contain any number of datasets and an index number is assigned to
       * each dataset based upon order of dataset creation. This event is raised when a node is
       * added by clicking on the menu button located at the left side bottom of the chart by
       * default but can the menu button location can be changed.
       *
       * This event is only applicable to DragNode chart.
       *
       * @event FusionCharts#nodeAdded
       * @group chart-powercharts:dragnode
       *
       * @param {number} datasetIndex - Index of the dataset to which the newly added
       * node belongs to.
       * @param {string} datasetName - Name of the dataset to which the node was added. Name of
       * the dataset can be defined by the attribute `seriesName` for `dataset` tag in the chart
       * data.
       * @param {number} dataIndex - Index of the newly added node.
       *
       * @param {number} height - Height of the shape represented by the newly added node.
       * @param {string} id - ID of the newly added node which can be set using `id` attribute
       * for `set` tag.
       *
       * @param {string} label - Text displayed inside the shape of the newly added node.
       * @param {string} link - URL associated with the newly added node.
       * @param {number} radius - Radius of the circumcirle for the shape of the
       * newly added node.
       * @param {string} shape - Shape of the newly added node.
       * @param {number} sides - Depending on the shape of the node it is the
       * number of sides of the polygon. If it is a circle it will have 0 sides.
       * @param {string} toolText - Text that is displayed over the shape of the
       * newly added node.
       * @param {number} width - Width of the shape of the newly added node.
       * @param {number} x - X Co-ordinate of the newly added node in reference with
       * the canvas / axis.
       * @param {number} y - Y Co-ordinate of the newly added node in reference with
       * the canvas / axis.
       */
      chart.fireChartInstanceEvent('chartupdated', extend2({
        sourceEvent: sourceEvent
      }, eventArgs));
      chart.fireChartInstanceEvent(sourceEvent, eventArgs);
      dataset._setupKdTree();
    }
  }

  /**
   * Function for updating existing nodes
   * @param {Object} updateObj Contains information about the node that is to be updated
   */
  updateNode (updateObj) {
    var groupManager = this,
      datasets = groupManager.getChildren('dataset'),
      len = datasets.length, // eslint-disable-line good-practices/no-single-usage-variable
      dataLen,
      idFound,
      dataset,
      dataObj,
      i,
      dataStore,
      eventArgs,
      sourceEvent = NODE_UPDATED,
      chart = groupManager.getFromEnv('chart'),
      j;
    updateObj.update = true;
    for (i = 0; i < len; i++) {
      dataset = datasets[i];
      dataStore = dataset.components.data || [];
      dataLen = dataStore.length;
      for (j = 0; j < dataLen; j++) {
        dataObj = dataStore[j];
        if (dataObj.config.id === updateObj.id) {
          idFound = true;
          break;
        }
      }
    }

    if (dataset && idFound) {
      eventArgs = {
        index: j, // to be deprecated
        dataIndex: j,
        link: updateObj.link,
        y: updateObj.y,
        x: updateObj.x,
        shape: updateObj.shape,
        label: updateObj.name,
        toolText: updateObj.tooltext,
        id: updateObj.id,
        datasetIndex: dataset.config.datasetIndex,
        datasetName: dataset.config.seriesname,
        sourceType: 'dataplot'
      };

      // configure the eventArgs based on the type of shape
      makeShapeSpecificModifications(eventArgs, updateObj);

      dataset._setConfigure(j, updateObj);
      dataset.parsePlotAttributes(j);
      dataset._drawNode(j);
      dataset.setState('dirty', true);
      chart.fireChartInstanceEvent('chartupdated', extend2({
        sourceEvent: sourceEvent
      }, eventArgs));
      chart.fireChartInstanceEvent(sourceEvent, eventArgs);
      dataset._setupKdTree();
    }
  }

  /**
   * Function for deleting a node
   * @param {Stirng} id The id of the node that is to be deleted
   */
  deleteNode (id) {
    var manager = this,
      node = manager.getNode(id),
      // node = nodes[id],
      dataset,
      dataStore,
      startConnectors,
      endConnectors,
      i,
      graphics,
      connector,
      dataObj,
      prop,
      len,
      eventArgs,
      config,
      idFound,
      sourceEvent = NODE_DELETED,
      chart = manager.getFromEnv('chart');
    if (node) {
      dataset = node.dataset;
      dataStore = dataset.components.data;
      startConnectors = node.config.startConnectors;
      endConnectors = node.config.endConnectors;
      len = dataStore.length;
      for (i = 0; i < len; i++) {
        dataObj = dataStore[i];
        if (dataObj.config.id === id) {
          idFound = true;
          break;
        }
      }

      if (idFound === true) {
        graphics = dataObj.graphics;
        removeElems(graphics);
        for (prop in startConnectors) {
          connector = startConnectors[prop] || {};
          graphics = connector.graphics;
          removeElems(graphics);
          delete connector.graphics;
          connector.removed = true;
        }
        for (prop in endConnectors) {
          connector = endConnectors[prop] || {};
          graphics = connector.graphics;
          removeElems(graphics);
          delete connector.graphics;
          connector.removed = true;
        }
        // delete nodes[id];
        dataObj.removed = true;
        config = dataObj.config || {};
        eventArgs = {
          index: i,
          dataIndex: i,
          link: config.link,
          y: config.y,
          x: config.x,
          shape: config.shape,
          label: config.displayValue,
          toolText: config.toolText,
          id: config.id,
          datasetIndex: dataset.config.datasetIndex,
          datasetName: dataset.config.seriesname,
          sourceType: 'dataplot'
        };

        // configure the eventArgs based on the type of shape
        makeShapeSpecificModifications(eventArgs, {
          width: config.width,
          height: config.height,
          radius: config.radius,
          numsides: config.numSides
        });

        chart.fireChartInstanceEvent('chartupdated', extend2({
          sourceEvent: sourceEvent
        }, eventArgs));
        chart.fireChartInstanceEvent(sourceEvent, eventArgs);
        dataset._setupKdTree();
      }
    }
  }

  /**
   * Function for adding new connectors
   * @param {Object} connectorObj Contains information about the connector that is to be added
   */
  addConnector (connectorObj) {
    var manager = this,
      // groupManager = chart.components['datasetGroup_' + chart.defaultDatasetType],
      connectors = manager.getChildren('connector')[0],
      // connectors = connectorSets[0].connectors,
      sourceEvent = CONNECTOR_ADDED,
      eventArgs,
      chart = manager.getFromEnv('chart');
    connectorObj.add = true;
    connectors._setConfigure(connectors.components.data.length, connectorObj);
    eventArgs = {
      arrowAtEnd: Boolean(connectorObj.arrowatend),
      arrowAtStart: Boolean(connectorObj.arrowatstart),
      fromNodeId: connectorObj.from,
      id: connectorObj.id,
      label: connectorObj.label,
      link: connectorObj.connectorLink,
      sourceType: 'connector',
      toNodeId: connectorObj.to
    };
    chart.fireChartInstanceEvent('chartupdated', extend2({
      sourceEvent: sourceEvent
    }, eventArgs));
    chart.fireChartInstanceEvent(sourceEvent, eventArgs);
    connectors.asyncDraw();
  }

  /**
   * Function for updating existing connectors
   * @param {Object} connectorObj Contains information about the connector that is to be updated
   */
  editConnector (connectorObj) {
    var manager = this,
      connectorSets = manager.getChildren('connector'),
      i,
      conLen,
      data,
      dataObj,
      fromId,
      toId,
      j,
      idFound,
      connectors,
      config,
      eventArgs,
      chart = manager.getFromEnv('chart'),
      sourceEvent = CONNECTOR_UPDATED,
      len = connectorSets.length; // eslint-disable-line good-practices/no-single-usage-variable
    for (i = 0; i < len; i++) {
      connectors = connectorSets[i];
      data = (connectors && connectors.components.data) || [];
      conLen = data.length;
      for (j = 0; j < conLen; j++) {
        dataObj = data[j];
        config = dataObj.config;
        fromId = config.from;
        toId = config.to;
        if (fromId === connectorObj.from && toId === connectorObj.to) {
          idFound = true;
          break;
        }
      }
    }
    connectorObj.update = true;
    if (idFound) {
      connectors._setConfigure(j, connectorObj);
      eventArgs = {
        arrowAtEnd: Boolean(connectorObj.arrowatend),
        arrowAtStart: Boolean(connectorObj.arrowatstart),
        fromNodeId: connectorObj.from,
        id: connectorObj.id,
        label: connectorObj.label,
        link: connectorObj.link,
        sourceType: 'connector',
        toNodeId: connectorObj.to
      };
      chart.fireChartInstanceEvent('chartupdated', extend2({
        sourceEvent: sourceEvent
      }, eventArgs));
      chart.fireChartInstanceEvent(sourceEvent, eventArgs);
      connectors.asyncDraw();
    }
  }

  /**
   * Function for deleting a connector
   * @param {Object} config Contains information about the connector that is to be deleted
   */
  deleteConnector (config) {
    var manager = this,
      connectorSets = manager.getChildren('connector'),
      i,
      j,
      dataObj,
      dataStore,
      dataLen,
      connFound = false, // eslint-disable-line good-practices/no-single-usage-variable
      connectors,
      eventArgs,
      connConfig,
      len = connectorSets.length, // eslint-disable-line good-practices/no-single-usage-variable
      sourceEvent = CONNECTOR_DELETED,
      chart = manager.getFromEnv('chart');

    for (i = 0; i < len; i++) {
      connectors = connectorSets[i];
      dataStore = connectors.components.data;
      dataLen = dataStore.length;
      for (j = 0; j < dataLen; j++) {
        dataObj = dataStore[j];
        if (dataObj.config.from === config.from && dataObj.config.to === config.to) {
          connFound = true;
          break;
        }
      }
    }
    if (connFound) {
      connConfig = dataObj.config || {};
      eventArgs = {
        arrowAtEnd: connConfig.arrowAtEnd,
        arrowAtStart: connConfig.arrowAtStart,
        fromNodeId: connConfig.from,
        id: connConfig.id,
        label: connConfig.label,
        link: connConfig.connectorLink,
        sourceType: 'connector',
        toNodeId: connConfig.to
      };
      removeElems(dataObj.graphics);
      delete dataObj.graphics;
      // Mark data object as removed
      dataObj.removed = true;
      chart.fireChartInstanceEvent('chartupdated', extend2({
        sourceEvent: sourceEvent
      }, eventArgs));
      chart.fireChartInstanceEvent(sourceEvent, eventArgs);
    }
  }

  /**
   * Generic function for creating a html UI box
   * @param {number} dialogWidth The width of the dialog box
   * @param {number} dialogHeight The height of the dialog box
   * @param {Function} onsubmit Callback functions
   * @param {Function} oncancel Callback functions
   * @param {Function} onremove Callback functions
   * @param {Object} cacheUI If the dialog box or its components are created then they are sent via this object so that
   * they are not re-created.
   * @return {HTMLElement} The final created html UI box
   */
  createHtmlDialog (dialogWidth, dialogHeight, onsubmit, oncancel, onremove, cacheUI) {
    var manager = this,
      // paper = manager.getFromEnv('paper'),
      conf = manager.getFromEnv('chartConfig'),
      inCanvasStyle = manager.getFromEnv('style').inCanvasStyle || {},
      chartWidth = Number(conf.width),
      chartHeight = Number(conf.height),
      animationManager = manager.getFromEnv('animationManager'),
      padding = 5,
      uiok,
      uicancel,
      uiremove,
      dialogAttrs,
      okAttrs,
      cancelAttrs,
      removeAttrs,
      buttonStyle = {
        color: hashify(inCanvasStyle.color),
        textAlign: 'center',
        paddingTop: 1 + PX,
        border: '1px solid #cccccc',
        borderRadius: 4 + PX,
        cursor: preDefStr.POINTER,
        '_cursor': 'hand',
        backgroundColor: HASHSTRING + COLOR_FFFFFF,
        zIndex: 21,
        '-webkit-border-radius': 4 + PX
      },
      ui = cacheUI,
      attrObj;

    attrObj = {
      width: chartWidth,
      height: chartHeight
    };
    if (!cacheUI) {
      attrObj.fill = TRANSPARENT;
      attrObj.type = DIV_STR;
    }

    ui = animationManager.setAnimation({
      el: cacheUI || 'html',
      attr: attrObj,
      component: manager,
      label: 'ui',
      state: DATASETSTATE,
      css: {
        fontSize: 10 + PX,
        lineHeight: 15 + PX,
        fontFamily: inCanvasStyle.fontFamily,
        display: 'block'
      },
      container: !cacheUI && manager.getFromEnv('chart-container')
    });

    attrObj = {
      width: chartWidth,
      height: chartHeight,
      opacity: 0.3
    };
    if (!ui.veil) {
      attrObj.fill = COLOR_000000;
      attrObj.type = DIV_STR;
    }

    ui.veil = animationManager.setAnimation({
      el: ui.veil || 'html',
      attr: attrObj,
      component: manager,
      state: DATASETSTATE,
      label: 'uiveil',
      container: !ui.veil && ui
    });

    dialogAttrs = {
      x: (chartWidth - dialogWidth) / 2,
      y: (chartHeight - dialogHeight) / 2,
      width: dialogWidth,
      height: dialogHeight
    };

    if (!ui.dialog) {
      dialogAttrs.fill = COLOR_EFEFEF;
      dialogAttrs.strokeWidth = 1;
      dialogAttrs.stroke = COLOR_000000;
      dialogAttrs.type = DIV_STR;
    }

    ui.dialog = animationManager.setAnimation({
      el: ui.dialog || 'html',
      attr: dialogAttrs,
      component: manager,
      state: DATASETSTATE,
      label: 'uidialog',
      container: !ui.dialog && ui,
      css: {
        borderRadius: 5 + PX,
        boxShadow: '1px 1px 3px #000000',
        '-webkit-border-radius': 5 + PX,
        '-webkit-box-shadow': '1px 1px 3px #000000',
        filter: 'progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color="#000000")'
      }
    });

    okAttrs = {
      x: dialogWidth - 70 - padding,
      y: dialogHeight - 23 - padding,
      width: 65,
      height: 17
    };
    if (!ui.ok) {
      okAttrs.text = SUBMIT_STR;
      okAttrs.tabIndex = 1;
      okAttrs.type = DIV_STR;
    }
    uiok = animationManager.setAnimation({
      el: ui.ok || 'html',
      state: DATASETSTATE,
      attr: okAttrs,
      component: manager,
      label: 'uiok',
      css: buttonStyle,
      container: !ui.ok && ui.dialog
    });

    !ui.ok && (ui.ok = uiok) && uiok.on('fc-mousedown', onsubmit);

    cancelAttrs = {
      x: dialogWidth - 140 - padding,
      y: dialogHeight - 23 - padding,
      width: 65,
      height: 17
    };

    if (!ui.cancel) {
      cancelAttrs.text = CANCEL_STR;
      cancelAttrs.tabIndex = 2;
      cancelAttrs.type = DIV_STR;
    }

    uicancel = animationManager.setAnimation({
      el: ui.cancel || 'html',
      state: DATASETSTATE,
      attr: cancelAttrs,
      component: manager,
      label: 'uicancel',
      css: buttonStyle,
      container: !ui.cancel && ui.dialog
    });

    !ui.cancel && (ui.cancel = uicancel) && uicancel.on('fc-mousedown', oncancel);

    removeAttrs = {
      x: dialogWidth - 210 - padding,
      y: dialogHeight - 23 - padding,
      width: 65,
      height: 17
    };
    if (!ui.removeItem) {
      removeAttrs.text = DELETE_STR;
      removeAttrs.tabIndex = 3;
      removeAttrs.type = DIV_STR;
    }

    uiremove = animationManager.setAnimation({
      el: ui.removeItem || 'html',
      state: DATASETSTATE,
      attr: removeAttrs,
      component: manager,
      label: 'uiremove',
      css: buttonStyle,
      container: !ui.removeItem && ui.dialog
    });

    !ui.removeItem && (ui.removeItem = uiremove) && uiremove.on('fc-mousedown', onremove);

    if (!ui.handleKeyPress) {
      // Add an event that would handle enter and esc on input
      // elements
      ui.handleKeyPress = function (e) {
        if (e.keyCode === 13) {
          // fire the mousedown handler when enter is pressed
          ui.ok.element && onsubmit(e);
        } else if (e.keyCode === 27) {
          // fire the mousedown handler when escape is pressed
          ui.cancel.element && oncancel(e);
        }
      };
    }

    // Keep initially hidden.
    // ui.hide();
    return ui;
  }

  /**
   * Function to get a specific node after querying all the datasets
   * @param {string} nodeId The node's id whose corresponding data object is required
   * @return {Object} The specific node or all the nodes from all the datasets
   */
  getNode (nodeId) {
    var node,
      nodes = {},
      datasets = this.getChildren('dataset');

    for (let i = 0, len = datasets.length; i < len; i++) {
      if (nodeId) {
        if ((node = datasets[i].getNode(nodeId))) {
          return node;
        }
      } else {
        Object.assign(nodes, datasets[i].getNode());
      }
    }
    return !nodeId && nodes;
  }

  /**
   * Create child containers
   */
  createContainer () {
    let manager = this,
      animationManager = manager.getFromEnv('animationManager'),
      keys = ['connectorGroup', 'defaultVcanvasGroup', 'vcanvasLabelGroup', 'cloneGroup'], // eslint-disable-line good-practices/no-single-usage-variable
      parentChildContainers = manager.getLinkedParent().getChildContainer();

    keys.forEach(function (key) {
      !manager.getChildContainer(key) && manager.addChildContainer(key,
        animationManager.setAnimation({
          el: 'group',
          attr: { name: 'manager-' + key },
          component: manager,
          container: parentChildContainers[key] || parentChildContainers.defaultVcanvasGroup
        }));
    });

    !manager.getContainer('waitContainer') && manager.addContainer('waitContainer',
      animationManager.setAnimation({
        el: 'group',
        attr: { name: 'manager-waitContainer' },
        container: parentChildContainers.defaultVcanvasGroup,
        component: manager
      }));
  }
  /**
   * Function to draw all the containers and repoition the html dialog box on chart-redraw
   */
  draw () {
    var manager = this,
      graphicalMap = {
        cacheUpdateUI: [350, 215],
        cacheLabelDeleteUI: [250, 100],
        cacheLabelUpdateUI: [350, 205],
        cacheConnectorUpdateUIedit: [315, 215],
        cacheConnectorUpdateUInew: [315, 215]
      },
      graphics,
      elem;
    if (!manager.getState('configured')) {
      DATASETSTATE = UPDATE_STR;
      for (graphics in graphicalMap) {
        if ((elem = manager.getGraphicalElement(graphics)) && elem.isVisible()) {
          if (graphics === 'cacheUpdateUI') {
            let fields = elem.fields,
              ele = fields.image,
              isChecked = ele.val();
            graphicalMap[graphics][1] = isChecked ? 250 : 215;
          }
          manager.createHtmlDialog(graphicalMap[graphics][0], graphicalMap[graphics][1], UNDEF,
            UNDEF, UNDEF, elem);
        }
      }
      DATASETSTATE = APPEARING_STR;
    }
    manager.setState('configured', false);
    manager.createContainer();
  }

  /**
   * function to get data limits from its child datasets
   * return minimun and maximum value among the datasets limit
   * @return {Object} [min, max]
   */
  getDataLimits () {
    var datasets = this.getChildren('dataset'),
      i,
      yMin = +Infinity,
      yMax = -Infinity,
      xMax = -Infinity,
      xMin = +Infinity,
      conf;
    for (i = 0; i < datasets.length; i++) {
      conf = datasets[i].config;
      yMax = Math.max(yMax, conf.yMax);
      yMin = Math.min(yMin, conf.yMin);
      xMax = Math.max(xMax, conf.xMax);
      xMin = Math.min(xMin, conf.xMin);
    }

    return {
      max: yMax,
      min: yMin,
      xMax: xMax,
      xMin: xMin
    };
  }
  /**
   * it return the status of dataset visiblity
   * @return {boolean} returns the visiblity status of dataset
   */
  isVisible () {
    return !this.isNotVisible;
  }

  /**
   * Over writing the childChanged function of the parent, basically a dummy function.
   * @return {Object} instance of DragNodeGroup class
   */
  childChanged () {
    return this;
  }

  /**
   * Function to hide the circular ring element
   */
  hideWaitElem () {
    this.getGraphicalElement('waitElement') && this.getGraphicalElement('waitElement').hide();
  }

  /**
   * Function to clear the setTimeout of that is set when a long press is triggered on the nodes, connectors and labels
   */
  clearLongPress () {
    var manager = this;
    clearTimeout(manager.config._longpressactive);
    delete manager.config._longpressactive;
  }

  /**
   * Function to set the timer after which the UI for deleting labels will open
   * @param {SVGElement} ele The element over which the click is done
   * @param {Object} labelObj Conatins the information about the label that is clicked
   */
  triggerLabelUI (ele, labelObj) {
    var manager = this;
    manager.config._longpressactive = setTimeout(function () {
      ele.data('fire_click_event', 0);
      if (!ele.data('viewMode')) {
        manager.showLabelDeleteUI(labelObj);
      }
    }, CLEAR_TIME_1000);
  }

  /**
   * Function to manage the UI box for editing connectors
   * @param {SVGElemet} ele The element on which the mousedown event is triggered
   */
  triggerConnectorUI (ele) {
    var manager = this,
      dataset = ele.data('dataset'),
      config = ele.data(preDefStr.configStr),
      options = config || {};
    manager.config._longpressactive = setTimeout(function () {
      // Whether to fire the click event ot not
      ele.data('fire_click_event', 0);

      if (!ele.data('viewMode')) {
        // add a selection method for start and end
        manager.showConnectorUpdateUI({
          fromid: {
            val: options.from,
            innerHTML: OPTIONSTR + options.from + OPTIONCLOSESTR,
            disabled: true
          },
          toid: {
            val: options.to,
            innerHTML: OPTIONSTR + options.to + OPTIONCLOSESTR,
            disabled: true
          },
          datasetIndex: dataset.config.datasetIndex,
          index: config.index,
          arratstart: {
            val: Boolean(pluckNumber(options.arrowatstart, 1))
          },
          arratend: {
            val: Boolean(pluckNumber(options.arrowatend, 1))
          },
          dashed: {
            val: pluckNumber(options.dashed)
          },
          dashgap: {
            val: options.dashgap
          },
          dashlen: {
            val: options.dashlen
          },
          label: {
            val: options.label
          },
          tooltext: {
            val: options.tooltext
          },
          id: {
            val: dataset.config.id,
            disabled: true
          },
          strength: {
            val: options.conStrength
          },
          alpha: {
            val: options.alpha
          },
          color: {
            val: options.color.FCcolor.color
          }
        }, true);
      }
    }, CLEAR_TIME_1000);
  }

  /**
   * Function to delete a label
   * @param {number} i The index of the label that is to be deleted
   */
  deleteLabel (i) {
    var manager = this,
      labels = manager.getChildren('labels')[0],
      index = pluckNumber(i, labels.config.lastTappedLabelIndex), // eslint-disable-line good-practices/no-single-usage-variable
      labelObj = labels.components.data[index],
      labelElement,
      trackerElement,
      chart = manager.getFromEnv('chart'),
      sourceEvent = LABEL_DELETED,
      eventArgs;

    labelElement = labelObj.graphics.element;
    trackerElement = labelObj.graphics.trackerElement;

    if (labelElement) {
      eventArgs = labelElement.data('eventArgs');
      labelElement.remove();
      trackerElement && trackerElement.remove();
      delete labelObj.graphics;
    }
    chart.fireChartInstanceEvent('chartupdated', extend2({
      sourceEvent: sourceEvent
    }, eventArgs));
    chart.fireChartInstanceEvent(sourceEvent, eventArgs);
    labelObj.removed = true;
  }

  /**
   * Function to show thw UI for deleting an existing label
   * @param {Object} label Conatains information about the label that is to be deleted
   */
  showLabelDeleteUI (label) {
    var manager = this,
      ui = manager.getGraphicalElement('cacheLabelDeleteUI');

    // Store the index of the last tapped label.
    manager.getChildren('labels')[0].config.lastTappedLabelIndex = label.config.index;
    if (!ui) {
      ui = manager.addGraphicalElement('cacheLabelDeleteUI',
        manager.createHtmlDialog(250, 100, UNDEF, function () {
          ui.hide();
        },
        function () {
          manager.deleteLabel();
          ui.hide();
        }));

      // create a location where to show the text message
      ui.message = manager.getFromEnv('paper').html('span', {
        x: 10,
        y: 10,
        width: 230,
        height: 80
      }).add(ui.dialog);
      // since submit button is not needed, hide it and move the
      // delete button to its place.
      ui.ok.hide();
      ui.removeItem.translate(175).show();
    } else {
      ui.show();
    }

    // Update the message with proper text.
    ui.message.attr({
      text: 'Would you really like to delete the label: \"' +
        label.config.text + '\"?'
    });
  }

  /**
   * Function to draw the circular ring and trigger the timer for opening the html box for editing the node
   * @param {Object} dataObj Conatins information about the node that is clicked
   * @param {number} datasetIndex The index of the dataset to which the node belongs
   */
  drawWaitingRing (dataObj, datasetIndex) {
    var manager = this,
      config = dataObj.config,
      conf = manager.getChildren('dataset')[datasetIndex].config,
      waitElement = manager.getGraphicalElement('waitElement');

    manager.clearLongPress();
    waitElement = manager.getFromEnv('animationManager').setAnimation({
      el: waitElement || 'ringpath',
      attr: {
        ringpath: [config._xPos, config._yPos, 8, 11, 0, 0],
        fill: toRaphaelColor({
          alpha: '100,100',
          angle: 120,
          color: 'CCCCCC,FFFFFF',
          ratio: '30,50'
        }),
        'stroke-width': 0
      },
      container: manager.getContainer('waitContainer'),
      component: manager
    });
    if (!manager.getGraphicalElement('waitElement')) {
      manager.addGraphicalElement('waitElement', waitElement);
    }
    // layerX += 11;
    // layerY -= 21;
    waitElement.show()
      .animate({
        ringpath: [config._xPos, config._yPos, 8, 11, 0, 6.28]
      }, CLEAR_TIME_1000);

    manager.config._longpressactive = setTimeout(function () {
      var seriesName = (conf.name !== BLANK && conf.name !== UNDEF)
          ? conf.name + preDefStr.BLANKSPACE : BLANK,
        seriesId = conf.id !== UNDEF ? (seriesName ? COMMASTRING : seriesName) + conf.id : BLANK;
      waitElement && waitElement.hide();
      // Whether to fire the click event ot not
      // ele.data('fire_click_event', 0);
      manager.showNodeUpdateUI({
        x: {
          value: config.x
        },
        y: {
          value: config.y
        },
        draggable: {
          value: getFirstValue(config.allowdrag, 1)
        },
        color: {
          value: config.color
        },
        alpha: {
          value: config.alpha
        },
        label: {
          value: getFirstValue(config.label,
            config.name)
        },
        tooltip: {
          value: config.toolText
        },
        shape: {
          value: shapesInfo[config.shape]
        },
        rectWidth: {
          value: config.width
        },
        rectHeight: {
          value: config.height
        },
        circPolyRadius: {
          value: config.radius
        },
        polySides: {
          value: config.numsides
        },
        image: {
          value: config.imageNode
        },
        imgWidth: {
          value: config.imageWidth
        },
        imgHeight: {
          value: config.imageHeight
        },
        imgAlign: {
          value: config.imageAlign
        },
        imgUrl: {
          value: config.imageURL
        },
        id: {
          value: config.id,
          disabled: true
        },
        link: {
          value: config.link
        },
        dataset: {
          innerHTML: '<option value="' +
              seriesId + '">' + seriesName +
              seriesId + '</option>',
          disabled: true
        },
        datasetIndex: datasetIndex
      }, true);
    }, CLEAR_TIME_1000);
  }

  /**
   * Function to draw connectors during dragging of the nodes
   * @param {Object} connectorsObj Contains information about connector object that is to be re-drawn
   */
  drawNodeConnectors (connectorsObj) {
    var i,
      datasetIndex,
      connectorSet,
      connector,
      fromObj,
      toObj;
    if (!connectorsObj) {
      return;
    }
    for (i in connectorsObj) {
      connector = connectorsObj[i];
      if (connector) {
        datasetIndex = connector.config.datasetIndex;
        fromObj = connector.config.fromPointObj;
        toObj = connector.config.toPointObj;
        connectorSet = this.getChildren('connector')[datasetIndex];

        if (connectorSet) {
          connectorSet && connectorSet.parsePlotAttributes(connector, fromObj, toObj);
          connectorSet && connectorSet.drawConnector(connector, fromObj, toObj);
        }
      }
    }
  }

  /**
   * Function to clear all the connectors if chart is updated.
   */
  _clearConnectors () {
    var nodes = this.getNode(),
      id,
      startConnectors,
      endConnectors,
      graphics,
      j,
      node;
    // Deleting all connectors from nodes object
    for (id in nodes) {
      node = nodes[id];
      if (node) {
        startConnectors = node.config.startConnectors || {};
        endConnectors = node.config.endConnectors || {};
        for (j in startConnectors) {
          graphics = {
            graphics: startConnectors[j].graphics || {}
          };
          componentDispose.call(graphics);
        }
        for (j in endConnectors) {
          graphics = {
            graphics: endConnectors[j].graphics || {}
          };
          componentDispose.call(graphics);
        }
      }
    }
    // // Clearing nodes object
    // manager.nodes = {};
  }

  /**
   * Function to get the jsonData from the datasets
   * @return {Object} data from the dataset
   */
  getJSONData () {
    var children = this.getChildren(),
      nodeSets = children.dataset,
      connectorSets = children.connector,
      labelSets = children.labels,
      jsonData = {},
      i,
      len,
      dataset;
    jsonData.dataset = [];
    jsonData.connectors = [];
    jsonData.labels = [];

    for (i = 0, len = nodeSets && nodeSets.length; i < len; i++) {
      dataset = nodeSets[i];
      if (!jsonData.dataset[i]) {
        jsonData.dataset[i] = extend2({}, dataset.JSONData);
      }
      jsonData.dataset[i].data = dataset.getJSONData();
    }
    for (i = 0, len = connectorSets && connectorSets.length; i < len; i++) {
      dataset = connectorSets[i];
      if (!jsonData.connectors[i]) {
        jsonData.connectors[i] = extend2({}, dataset.JSONData);
      }
      jsonData.connectors[i].connector = dataset.getJSONData();
    }
    for (i = 0, len = labelSets && labelSets.length; i < len; i++) {
      dataset = labelSets[i];
      if (!jsonData.labels[i]) {
        jsonData.labels[i] = {
          label: []
        };
      }
      jsonData.labels[i].label = dataset.getJSONData();
    }
    return jsonData;
  }
}
export default DragNodeGroup;
